"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importProxy = void 0;
/** Manually handling circular import so React Native does not gives warning. */
exports.importProxy = {};
//# sourceMappingURL=importProxy.js.map